
export const SESSION_STORAGE_KEYS = {
  IS_LOGIN: 'islogin',
  WRONG_ENVIRONMENT_DETECTED: 'wrongEnvironmentDetected',
  WRONG_ENVIRONMENT_TIMESTAMP: 'wrongEnvironmentDetected_timestamp',
  LAST_GATEWAY_ERROR: 'lastGatewayError',
  LOADING: 'loading',
  USER_NOT_FOUND_ERROR: 'userNotFoundError',
};

export const SESSION_STORAGE_VALUES = {
  TRUE: 'true',
  FALSE: 'false',
};


export const SESSION_STORAGE_SUFFIX = {
  TIMESTAMP: '_timestamp',
};
